export const ENDPOINTS = {
  GET_OPERATIONS_KPI_DETAILS: '/Operations/GetOperationsKpiDetails',
  GET_KPI_CARDS: '/Operations/GetKpiCards',
  RETRIEVE_USER_DETAILS: '/Security/RetrieveUserDetails',
  GET_OVERALL_DATA: '/Performance/GetOverallGraphData',
  GET_USER_DETAILS: '/Security/GetUserDetails',
  GET_ECOMM_SALES_PERFORMANCE: '/Performance/GetEcomSalesByFulfillment',
  GET_STORES_AND_PERMISSIONS:
    'https://apim-apiservices-np-1.azure-api.net/GetStoresAndPermissionFromIBToken',
  GET_YARD_RX: '/Performance/GetEcomYardRxAsync',
  GET_LOCAL_LIFT_MAX_DATA: '/Performance/GetLocalLiftMaxData',
  GET_PRODUCT_SYNC: '/Performance/GetEcomProductSyncAsync',
  GET_HIGHER_GROUND_STATUS: '/Header/GetHigherGroundStatus',
  GET_KOM_ROLLING: '/Performance/GetEcomKOMRolling',
  GET_ECOM_ORDER_DETAILS: '/Performance/GetEcomOrderDetails',
  LOG_CLICK_EVENT: '/ClickEvent',
  GET_HG_REPORT_DATA: '/Header/GetHGReportData',
  GET_SUMMARY_EXPORT: '/Header/GetSummaryExport',
  GET_SCORECARD: '/Scorecard/GetScorecard',
  GET_ADW_DASHBOARDS_TOKEN: '/AdwDashboards/GetAdwDashboardsToken',
};
